import { useMutation } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";

import { ENDPOINTS } from "../common/constants";

export const useSubmitApplicationMutation = (customerDomain: string) => {
  const client = useAxios();
  const url = ENDPOINTS.SUBMIT_SUBSEQUENT_APPLICATION.replace(":customerSlug", customerDomain);

  return useMutation<void, Error, void>({
    mutationFn: async () => {
      await client.post(url);
    },
  });
};
